export default __webpack_public_path__ + "static/media/halfCircle.f36b0155.png";